import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Checkbox, Button, FormLabel, TextField, FormControlLabel, Snackbar } from "@mui/material";
import { updateAgentCryptoCurrency } from "../../actions/agent";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router";

function AreaGradient({ color, id }) {
	return (
		<defs>
			<linearGradient id={id} x1="50%" y1="0%" x2="50%" y2="100%">
				<stop offset="0%" stopColor={color} stopOpacity={0.3} />
				<stop offset="100%" stopColor={color} stopOpacity={0} />
			</linearGradient>
		</defs>
	);
}

AreaGradient.propTypes = {
	color: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
};

const useStyles = makeStyles({
	snackbarStyleViaContentProps: {
		backgroundColor: "green",
	},
	snackbarStyleViaNestedContent: {
		backgroundColor: "lightgreen",
		color: "black",
	},
});

const AgentCurrency = ({ cryptoCurrency, network, image, activeDeposit, activeWithdrawal, freeplay, freeplayAmount, token }) => {
	const classes = useStyles();
	const [openSnack, setOpenSnack] = React.useState(false);
	const navigate = useNavigate();

	const updateCrypto = (e) => {
		e.preventDefault();
		const activeDepositform = document.getElementById(`chk${cryptoCurrency}-${network}`).checked;
		const activeWithdrawalform = document.getElementById(`chkw${cryptoCurrency}-${network}`).checked;
		const freeplayform = document.getElementById(`chkfp${cryptoCurrency}-${network}`).checked;
		const freeplayamountform = document.getElementById(`txt${cryptoCurrency}-${network}`).value;
		updateAgentCryptoCurrency(token, cryptoCurrency, network, activeDepositform, activeWithdrawalform, freeplayform, freeplayamountform, (res) => {
			if (!res.error) {
				setOpenSnack(true);
			} else {
				if (res.message.toString().includes("Token Expired")) {
					navigate("/logout");
				}
			}
		});
	};

	return (
		<Card variant="outlined" sx={{ height: "100%", flexGrow: 1 }}>
			<CardContent>
				<Box sx={{ display: "flex" }}>
					<img src={image} style={{ width: "24px", height: "24px", marginRight: 10 }} />
					<Typography component="h2" variant="subtitle2" gutterBottom>
						{cryptoCurrency}
					</Typography>
				</Box>
				<Box sx={{ display: "flex", mt: 2 }}>
					<Typography component="h2" variant="subtitle2" gutterBottom>
						{`NETWORK: ${network}`}
					</Typography>
				</Box>
				<Stack direction="column" sx={{ justifyContent: "space-between", flexGrow: "1", gap: 1 }}>
					<Stack sx={{ justifyContent: "space-between" }}>
						<Stack direction="row" sx={{ alignItems: "left", display: "flex" }}>
							<FormControlLabel
								control={
									<Checkbox
										edge="start"
										id={`chk${cryptoCurrency}-${network}`}
										name={`chk${cryptoCurrency}-${network}`}
										defaultChecked={activeDeposit}
										tabIndex={1}
										disableRipple
										//onChange={changeAgreement}
										sx={{ stroke: "#ffffff", strokeWidth: 1 }}
									/>
								}
								label="Active Deposits"
							/>
						</Stack>
						<Stack direction="row" sx={{ alignItems: "left", display: "flex" }}>
							<FormControlLabel
								control={
									<Checkbox
										edge="start"
										id={`chkw${cryptoCurrency}-${network}`}
										name={`chkw${cryptoCurrency}-${network}`}
										defaultChecked={activeWithdrawal}
										tabIndex={1}
										disableRipple
										//onChange={changeAgreement}
										sx={{ stroke: "#ffffff", strokeWidth: 1 }}
									/>
								}
								label="Active Withdrawals"
							/>
						</Stack>
						<Stack direction="row" sx={{ alignItems: "left" }}>
							<FormControlLabel
								control={
									<Checkbox
										edge="start"
										id={`chkfp${cryptoCurrency}-${network}`}
										name={`chkfp${cryptoCurrency}-${network}`}
										defaultChecked={freeplay}
										tabIndex={2}
										disableRipple
										//onChange={changeAgreement}
										sx={{ stroke: "#ffffff", strokeWidth: 1 }}
									/>
								}
								label="Apply Freeplay %"
							/>
						</Stack>
						<Stack direction="row" sx={{ alignItems: "left" }}>
							<Box sx={{ display: "flex", mt: 2, mb: 2 }}>
								<TextField
									name={`txt${cryptoCurrency}-${network}`}
									placeholder="Freeplay percentage"
									type="number"
									id={`txt${cryptoCurrency}-${network}`}
									fullWidth
									variant="outlined"
									color={"primary"}
									label="Freeplay %"
									defaultValue={freeplayAmount ?? ""}
								/>
							</Box>
						</Stack>
					</Stack>
					<Box sx={{ width: "100%", height: 50 }}>
						<Button fullWidth variant="contained" onClick={updateCrypto}>
							Update
						</Button>
					</Box>
				</Stack>
			</CardContent>
			<Snackbar
				anchorOrigin={{
					vertical: "center",
					horizontal: "center",
				}}
				ContentProps={{
					"aria-describedby": "message-id",
					className: classes.snackbarStyleViaContentProps,
				}}
				open={openSnack}
				onClose={() => setOpenSnack(false)}
				autoHideDuration={4000}
				message="Info Updated"
				sx={{ backgroundColor: "green" }}
			/>
		</Card>
	);
};

export default AgentCurrency;
